import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ContactAppResource from './ContactAppResource';
import InquiryAppResource from './InquiryAppResource';
import LeadDispositionAppResource from './LeadDispositionAppResource';
import LeadSourceAppResource from "./LeadSourceAppResource";
import LeadTypeAppResource from './LeadTypeAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';

class LeadAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Lead';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'leads';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'firstName',
            'middleName',
            'lastName',
            'fullName',
            'leadSourceCreatedAt',
            'leadType',
            'reference',
            'organizationUuid',
            'workspaceUuid',
            'contactUuid',
            'leadSourceUuid',
            'leadSubsourceUuid',
            'inquiryUuid',
            'leadSourceActivityDate',
            'leadSourceLeadTrackingNumber',
            'leadDeliveryMethod',
            'leadRoutingEmailAddress',
            'leadParserId',
            'organization',
            'workspace',
            'contact',
            'leadSource',
            'leadSubsource',
            'inquiry',
            'leadDisposition',
            'leadTypeUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            workspace: WorkspaceAppResource,
            contact: ContactAppResource,
            leadSource: LeadSourceAppResource,
            leadSubsource: LeadSourceAppResource,
            inquiry: InquiryAppResource,
            leadDisposition: LeadDispositionAppResource,
            leadType: LeadTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            workspace: 'workspace_uuid',
            contact: 'contact_uuid',
            leadSource: 'lead_source_uuid',
            leadSubsource: 'lead_subsource_uuid',
            inquiry: 'inquiry_uuid',
            leadType: 'lead_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            firstName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            lastName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            middleName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            fullName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            leadSourceCreatedAt: {
                presence: true,
                datetime: true,
            },
            leadTypeUuid: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            reference: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            workspaceUuid: {
                type: 'string',
            },
            contactUuid: {
                type: 'string',
            },
            leadSourceUuid: {
                type: 'string',
                presence: true,
            },
            leadSubsourceUuid: {
                type: 'string',
            },
            inquiryUuid: {
                type: 'string',
            },
            leadSourceActivityDate: {
                type: 'string',
                datetime: true,
            },
            leadSourceLeadTrackingNumber: {
                type: 'string',
                length: {
                    minimum: 255,
                },
            },
            leadDeliveryMethod: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            leadRoutingEmailAddress: {
                type: 'string',
                length: {
                    minimum: 255,
                },
            },
            leadParserId: {
                type: 'string',
                length: {
                    minimum: 255,
                },
            },
        };
    }

}

export default LeadAppResource;
